// extracted by css-extract-rspack-plugin
export default {"icons":"Ey3DBS1jkUD86QWX","description":"NYWjAFa1Y4MxWCXG","form":"hQR6sA05IkH9uomf","iconGroup":"F6HNSBnVM1wEsia2","label":"kAgplcjMJcc_hOxM"};